import { styled } from '../../../theme/stitches.config';
import type * as Stitches from '@stitches/react';

export const SMPKnockoutDesktopContainer = styled.withConfig({ componentId: 'CommonWidget', displayName: 'KnockoutDesktopContainer' })(
  'div',
  {
    overflowX: 'auto',
    overflowY: 'hidden',
    scrollBehavior: 'smooth',

    '> svg:nth-child(1)': {
      width: '10px',
      position: 'absolute',
      zIndex: 20,
      color: '$hiContrast',
      top: '34px',
      left: '29px',
      cursor: 'pointer',
    },
    '> svg:nth-child(1):hover, > svg:last-child:hover': {
      color: '$accentPrimaryBgColor',
      cursor: 'pointer',
      transition: 'color 0.3s',
    },
    '> svg:last-child': {
      width: '10px',
      position: 'absolute',
      zIndex: 20,
      top: '34px',
      color: '$hiContrast',
      cursor: 'pointer',
      right: '26px',
    },
  },
);
export type SMPKnockoutDesktopContainer = Stitches.VariantProps<typeof SMPKnockoutDesktopContainer>;
